import { useMutation } from '@tanstack/react-query'
import { useOrpc } from '@/hooks/useClient'

export function useReferralDraft() {
  const orpc = useOrpc()
  return useMutation(orpc.referralDraft.mutationOptions())
}

/** The draft endpoint answers SERVICE_UNAVAILABLE when drafting is not configured. */
export function isDraftUnavailable(err: unknown): boolean {
  return (err as { code?: string } | null)?.code === 'SERVICE_UNAVAILABLE'
}
